module.exports = __webpack_public_path__ + "static/martial_arts-4a8943a280e63e31ec73ced35c571786.jpg";